import { demutate, mutate, mutationTypes, updateWord } from './mutationUtils';

export const lowercaseHardMutations = {
  'g': 'k',
  'gw': 'kw',
  'b': 'p',
  'd': 't',
};

const hardMutations = {
  'g': 'k',
  'gw': 'kw',
  'b': 'p',
  'd': 't',
  'G': 'K',
  'GW': 'KW',
  'Gw': 'Kw',
  'B': 'P',
  'D': 'T',
};

const reverseMutations = {
  'k': 'g',
  'kw': 'gw',
  'p': 'b',
  't': 'd',
  'K': 'G',
  'KW': 'GW',
  'Kw': 'Gw',
  'P': 'B',
  'T': 'D',
};

export const provokersHardMutationsOnly = [
  'ho', 'ez', 'd\'az',
];

export function applyHardMutations (wordToMutateIdx, words) {

  updateWord(words[ wordToMutateIdx ],
    (word) => {
      mutate(word, hardMutations, mutationTypes.HARD);
    },
    (word) => {
      demutate(word, reverseMutations, mutationTypes.HARD);
    });
}
